/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IWinRatioConfig} from "../core/config/WinRatio";
import {BetWinMode} from "../core/config/BetWinMode";
import {IReelSets} from "../core/reel/reelset/ReelSet";
import {StackedSymbol} from "../core/reel/stackedsymbol/StackedSymbol";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class DDayGameConfig {

    // Game basic
    public static BET_WIN_MODE: BetWinMode = BetWinMode.BET_WAY;
    public static REELS_SYM_COUNT: number[] = [3, 4, 5, 4, 3];
    public static SYMBOL_HEIGHT: number = 118;
    public static SYMBOL_WIDTH: number = 144;
    // Reels
    public static REELS_NUM: number = 5;

    public static REELS = [["L1", "L1", "M1", "M1", "M3"], ["L1", "M1", "L2", "M3", "M1", "L1"], ["L1", "M3", "L1", "L1", "M3", "M1", "L1"], ["L1", "L1", "L1", "M3", "M3", "M1"], ["L1", "L1", "M3", "M1", "L1"]]

    // win
    public static WIN_RATIOS: IWinRatioConfig[] = [
        {
            index: 0,
            ratio: 0,
            name: "Tiny win",
            duration: 0,
            bigWinLevel: -1
        },
        {
            index: 1,
            ratio: 1.5,
            name: "Small win",
            duration: 0,
            bigWinLevel: -1
        },
        {
            index: 2,
            ratio: 3,
            name: "Medium win",
            duration: 0.4,
            bigWinLevel: -1
        },
        {
            index: 3,
            ratio: 5,
            name: "Large win",
            duration: 0.8,
            bigWinLevel: -1
        },
        {
            index:4,
            ratio: 15,
            name: "Big win 1",
            duration: 6,
            bigWinLevel: 0
        },
        {
            index: 5,
            ratio: 25,
            name: "Big win 2",
            duration: 8,
            bigWinLevel: 1

        },
        {
            index: 6,
            ratio: 50,
            name: "Big win 3",
            duration: 8,
            bigWinLevel: 2
        },
        {
            index: 7,
            ratio: 100,
            name: "Big win 4",
            duration: 9,
            bigWinLevel: 3
        },
        {
            index: 8,
            ratio: 500,
            name: "Big win 5",
            duration: 9,
            bigWinLevel: 4
        }
    ];

    public static REEL_SETS: IReelSets = {
        "NORMAL_REELSET": [
            [
                "L4", "M1", "M3", "M2", "M2", "M4", "M4", "L4", "L2", "L2", "L2", "M3", "L3", "L1", "M1", "L4", "M3", "L2", "L3", "M1",
                "M1", "S", "L4", "M4", "L3", "L2", "M2", "L4", "S", "M1", "M1", "L2", "M3", "M3", "M3", "L3", "L3", "M4", "L4", "L2", "L1",
                "L3", "M2", "L4", "L4", "L2", "L2", "L1", "L1", "L3", "M2", "M2", "M2", "M4", "M4", "L4", "L1", "L2", "W", "L3", "M4", "S",
                "L1", "L2", "M1", "M1", "M1", "L3", "L4", "L4", "L4", "L1", "L2", "L2", "M1", "M3", "M4", "L4", "L3", "L1", "L1", "L2", "M2",
                "L4", "L4", "M4", "L1", "M1", "L3", "M3", "M3", "L4", "L2", "M2", "M2", "L3", "L1", "L4", "M3", "M3", "L2", "L3", "L1", "M4",
                "M4", "M4", "L4", "M3", "L3", "L2", "L1", "W", "M4", "M3", "L2", "L4", "L3", "M4", "M1", "L1", "L1", "L1", "L4", "L3", "M2",
                "M4", "L1", "L4", "M3", "M2", "L2", "M4", "L1", "L3", "L3", "M2", "L4", "M3", "L2", "L1", "L3", "L3", "L3"
            ],
            [
                "L1", "L1", "S", "L2", "L4", "L3", "M3", "L1", "M4", "M1", "L4", "M2", "M2", "M2", "L3", "L2", "M3", "M3", "M3", "L4", "M2",
                "M4", "M1", "L3", "L4", "L2", "W", "M1", "M1", "M1", "M3", "L4", "L3", "L1", "L2", "L2", "M2", "S", "L3", "M4", "M4", "L2",
                "L4", "M3", "L3", "L3", "L1", "L1", "L1", "M4", "M1", "M1", "L2", "L3", "M2", "L1", "L1", "L4", "S", "M3", "M3", "L3", "L1",
                "L4", "L4", "M4", "L2", "M2", "M2", "L3", "L4", "L4", "M1", "L1", "L2", "M4", "L4", "M2", "L3", "L2", "L1", "M1", "M3", "L4",
                "L2", "L1", "M4", "M3", "L4", "L2", "M2", "M2", "L1", "L3", "L3", "M3", "M1", "M1", "L2", "L2", "L2", "L4", "L1", "L3", "W",
                "M4", "L4", "L2", "M2", "L1", "L3", "M4", "M1", "M3", "M3", "L4", "L3", "L1", "L2", "M4", "M4", "M4", "L4", "L3", "M3", "L2",
                "L1", "M4", "M4", "L3", "L4", "L2", "L2", "L1", "M3", "M2", "L4", "L4", "L4", "L3", "L3", "L3", "M4"
            ],
            [
                "L2", "M4", "M4", "L3", "L4", "L4", "L4", "L1", "M3", "L2", "L2", "M4", "M4", "L4", "L3", "W", "L1", "M2", "L2", "L4", "W", "L3",
                "S", "L1", "L4", "M4", "M4", "M4", "L2", "L3", "L1", "M2", "M2", "M4", "L4", "L2", "L2", "L3", "M1", "M4", "L1", "M2", "L4", "L2",
                "M1", "M1", "L3", "L3", "M3", "M3", "M2", "M4", "L4", "L4", "L3", "M1", "L2", "M3", "W", "L1", "L1", "M1", "M1", "M1", "L4", "L2",
                "M3", "L3", "L1", "L1", "M1", "M1", "L4", "L2", "L3", "L1", "M1", "M2", "L4", "L3", "L3", "L3", "M3", "M1", "L2", "M4", "L3", "M2",
                "M2", "M2", "L4", "L4", "S", "L1", "M4", "M3", "M2", "L2", "L3", "M4", "M3", "L4", "L1", "W", "S", "M3", "L4", "L2", "L1", "M4", "M3",
                "L3", "L3", "L2", "W", "L4", "M4", "M3", "M3", "M3", "L1", "L3", "L4", "M2", "L2", "L2", "L2", "L1", "L1", "L1", "L3", "M3", "M3", "L4",
                "M2", "M2", "L2", "L1", "L3", "L4", "M1", "L2", "M4", "L3", "L4", "L1"
            ],
            [
                "L2", "M4", "L3", "W", "L1", "L2", "L2", "M3", "M4", "L4", "L3", "M2", "M2", "M2", "M3", "L1", "L2", "L4", "M4", "L3", "L3", "M1",
                "L1", "L4", "L2", "L3", "W", "M1", "L4", "M4", "L1", "L2", "L2", "M1", "L3", "M3", "M3", "L4", "L1", "L1", "L1", "M2", "M4", "L3",
                "M1", "L2", "L4", "S", "L3", "L3", "L1", "L1", "M4", "L4", "L2", "L3", "M3", "L1", "L4", "M2", "M2", "L2", "W", "M3", "L4", "L3",
                "M4", "M4", "L2", "L1", "W", "M2", "L4", "L4", "L4", "L2", "M4", "M4", "L3", "M1", "M1", "L4", "L1", "L2", "L3", "M3", "L4", "L4",
                "M1", "M1", "L2", "L1", "L3", "M4", "M2", "M1", "L4", "L1", "M3", "M3", "M3", "L2", "L3", "L4", "M4", "M4", "M4", "M3", "M3", "L2",
                "L2", "L2", "L3", "L1", "W", "M2", "L4", "M4", "L1", "L1", "M3", "L2", "M2", "M1", "M1", "M1", "L4", "L4", "M3", "L3", "S", "L2", "M2",
                "M2", "L4", "L3", "L3", "L3", "L1", "S", "M2", "M3", "M4", "L3", "L1", "L4"
            ],
            [
                "L3", "L3", "L3", "M2", "L1", "L4", "L2", "L3", "L3", "M4", "M2", "M2", "L4", "L1", "L3", "L2", "M2", "M3", "L1", "S2", "L3", "M4", "L4",
                "M2", "L2", "L3", "M1", "L4", "M4", "M4", "M4", "L1", "L2", "M3", "L3", "M4", "M4", "M1", "M1", "L4", "M3", "M3", "M3", "L3", "L1", "L2",
                "M1", "S2", "L3", "L4", "M4", "L1", "M1", "L2", "M2", "M2", "M2", "L4", "L3", "M3", "M4", "L2", "L4", "L1", "L3", "M4", "M4", "L2", "M1",
                "M1", "M1", "M3", "M3", "M2", "M4", "S2", "L3", "L4", "L2", "L1", "M1", "W", "M4", "L3", "L3", "L4", "L1", "L1", "M3", "L2", "M4", "L4",
                "L1", "M2", "L2", "L3", "L4", "L4", "M1", "L1", "L1", "W", "L2", "L2", "L4", "L4", "L4", "M4", "L3", "M3", "L2", "L4", "M2", "W", "L1",
                "M3", "M3", "L4", "M2", "M2", "L2", "L2", "M4", "L3", "L1", "L1", "L1", "L4", "M3", "L2", "L2", "L2", "L3", "M1", "M1", "L4", "W", "L1",
                "L3", "M3", "L4", "L4", "L2", "L1", "W", "M3"
            ]
        ],
        "FREESPIN_REELSET": [
            [
                "L2", "M4", "L3", "M3", "M3", "M3", "L4", "W", "L1", "L1", "L1", "L2", "M1", "M4", "M4", "L3", "L1", "L2", "L2", "L4", "M2",
                "L3", "L1", "M1", "M1", "L4", "M2", "M2", "M2", "L2", "M4", "L1", "M3", "L3", "M1", "M1", "L4", "L2", "L1", "M2", "L3", "M3",
                "M4", "L2", "L4", "L1", "M3", "M4", "M1", "L3", "L4", "L4", "L2", "L1", "M4", "M4", "M4", "L3", "M2", "L4", "L1", "L2", "M3",
                "M3", "M2", "L3", "L1", "L1", "M4", "L4", "L4", "L4", "L2", "L2", "L3", "M1", "M3", "L1", "L4", "L2", "L3", "M3", "M4", "L4",
                "L2", "L3", "M3", "L1", "L4", "M4", "M4", "L3", "L2", "M3", "M3", "M1", "M1", "M1", "L4", "M2", "L1", "L3", "L3", "L2", "L4",
                "M2", "M1", "L3", "L3", "M3", "M4", "L1", "L2", "L4", "L4", "L3", "M1", "M4", "M2", "M2", "L4", "L2", "L2", "L2", "L1", "W",
                "L3", "L3", "L3", "M4", "L4", "L2", "M3", "L3", "L1", "L1", "M2", "M2", "L4"
            ],
            [
                "L2", "L2", "L2", "L3", "L1", "M3", "L4", "M4", "L2", "L3", "M1", "M2", "M2", "L4", "L2", "L1", "L3", "M3", "M4", "L4", "L4",
                "L1", "L2", "L3", "M2", "M4", "M4", "M3", "L1", "L2", "L2", "L3", "L4", "M4", "L1", "L2", "L3", "L4", "M2", "M4", "M4", "M4",
                "M1", "L1", "L4", "L3", "L2", "M4", "M4", "M1", "L4", "M2", "L1", "L2", "L3", "L4", "M1", "M1", "M1", "M3", "M4", "L3", "L1",
                "L1", "L1", "L2", "L4", "L4", "L4", "M3", "M3", "M3", "L3", "M2", "M1", "M4", "L1", "L4", "L2", "M1", "M1", "M3", "L3", "L1",
                "L1", "L4", "M4", "L2", "M1", "M1", "W", "L3", "M3", "M3", "L4", "L1", "M2", "M2", "M2", "L2", "L2", "M1", "L4", "M4", "L3",
                "L3", "L1", "L1", "L2", "M2", "M2", "M4", "L4", "L3", "M3", "L1", "W", "L2", "L3", "L3", "L3", "L4", "L4", "M4", "M3", "M2",
                "L1", "L4", "L2", "L3", "M3", "M3", "L1", "L4", "L2", "L3", "L3", "M3", "M2", "L4"
            ],
            [
                "M4", "L3", "M3", "L1", "M1", "M2", "L3", "L4", "L2", "L2", "M4", "M3", "M3", "L3", "L1", "L4", "M4", "M1", "L2", "L3", "L4",
                "L4", "L4", "M4", "M4", "M3", "L2", "L1", "L4", "M2", "M1", "L3", "L1", "L4", "L4", "M3", "M4", "M2", "L2", "L2", "L2", "L3",
                "L3", "L4", "L1", "W", "M3", "L2", "L2", "L4", "L3", "M4", "M4", "M2", "L2", "L1", "L1", "L1", "L4", "M3", "M2", "L3", "L3",
                "M1", "M1", "L1", "L2", "M3", "L4", "M4", "L1", "M2", "M2", "M2", "L3", "L4", "M4", "L2", "L1", "L1", "M1", "M1", "M1", "L3",
                "M4", "L2", "L1", "L1", "L4", "M2", "M2", "M1", "M1", "M3", "L3", "L2", "L4", "L1", "M4", "M4", "M4", "L3", "L2", "M1", "L4",
                "L1", "M2", "L3", "M3", "M3", "M3", "L4", "L1", "L2", "W", "L3", "L4", "L1", "L2", "M4", "L3", "L4", "M3", "L1", "L2", "M1",
                "L3", "L3", "L3", "M4", "L4", "L4", "L2", "M3", "M3", "L3", "M2", "M2", "L4", "L2"
            ],
            [
                "L4", "L4", "M4", "L3", "L1", "L2", "L4", "M1", "M4", "L3", "L1", "L4", "L2", "L2", "M3", "L3", "M1", "M1", "W", "L2", "L4",
                "L3", "M2", "L1", "L2", "L4", "M1", "M2", "M2", "L1", "M3", "L3", "M4", "M4", "M4", "L2", "L4", "M3", "L3", "M4", "L1", "W",
                "L2", "L4", "L3", "M3", "M2", "M2", "M2", "L2", "L1", "L4", "L3", "M4", "M2", "L2", "L4", "L4", "L4", "M1", "L3", "L3", "L3",
                "M4", "M4", "L1", "L1", "L2", "L4", "M3", "M3", "L3", "L3", "M2", "L1", "L1", "L1", "M4", "M3", "L4", "L2", "L3", "M4", "M1",
                "M3", "M3", "M3", "L4", "L1", "M2", "M4", "M4", "L3", "L4", "L4", "L1", "M1", "M1", "M3", "L2", "L2", "L4", "M2", "L1", "L3",
                "M4", "M1", "M1", "M1", "L4", "L1", "L2", "M4", "L3", "L3", "M2", "M2", "L4", "L2", "M3", "M3", "L1", "L3", "M4", "L2", "L4",
                "M3", "M1", "L1", "L1", "L3", "L2", "M3", "L4", "L1", "L3", "L2", "L2", "L2", "M2"
            ],
            [
                "L1", "M2", "M4", "M4", "M4", "L2", "M3", "L4", "L3", "L3", "M4", "M4", "M2", "M1", "L2", "L3", "M3", "L1", "L4", "L2", "M4",
                "M1", "M1", "L3", "L4", "L1", "M4", "M4", "M2", "L2", "L3", "L1", "L4", "M3", "M3", "M3", "M1", "M1", "L2", "L1", "L3", "L4",
                "M4", "M3", "M3", "M2", "M2", "L2", "L2", "L1", "L3", "L4", "M4", "W", "M3", "L1", "L3", "L3", "L4", "L2", "M1", "M1", "M1",
                "M2", "L3", "M4", "L4", "L2", "L1", "L3", "M4", "W", "L4", "M3", "M2", "M2", "M2", "L2", "M4", "L1", "L3", "M3", "L4", "M1",
                "L2", "L2", "L3", "L1", "L1", "L4", "M2", "M2", "L2", "L3", "M3", "L4", "L4", "L4", "L1", "M2", "L3", "M4", "L4", "L2", "L2",
                "L2", "L1", "M1", "M3", "M3", "L3", "L2", "L4", "L4", "M1", "L1", "L1", "M4", "L3", "L4", "L4", "M3", "L2", "M2", "M1", "L4",
                "L1", "L2", "M4", "L3", "L3", "L3", "L4", "L1", "L1", "L1", "L2", "M3", "L3", "L4"
            ]
        ],
        "SUPER_FREESPIN_REELSET": [
            [
                "L2", "M4", "L3", "M3", "M3", "M3", "L4", "W", "L1", "L1", "L1", "L2", "M1", "M4", "M4", "L3", "L1", "L2", "L2", "L4", "M2",
                "L3", "L1", "M1", "M1", "L4", "M2", "M2", "M2", "L2", "M4", "L1", "M3", "L3", "M1", "M1", "L4", "L2", "L1", "M2", "L3", "M3",
                "M4", "L2", "L4", "L1", "M3", "M4", "M1", "L3", "L4", "L4", "L2", "L1", "M4", "M4", "M4", "L3", "M2", "L4", "L1", "L2", "M3",
                "M3", "M2", "L3", "L1", "L1", "M4", "L4", "L4", "L4", "L2", "L2", "L3", "M1", "M3", "L1", "L4", "L2", "L3", "M3", "M4", "L4",
                "L2", "L3", "M3", "L1", "L4", "M4", "M4", "L3", "L2", "M3", "M3", "M1", "M1", "M1", "L4", "M2", "L1", "L3", "L3", "L2", "L4",
                "M2", "M1", "L3", "L3", "M3", "M4", "L1", "L2", "L4", "L4", "L3", "M1", "M4", "M2", "M2", "L4", "L2", "L2", "L2", "L1", "W",
                "L3", "L3", "L3", "M4", "L4", "L2", "M3", "L3", "L1", "L1", "M2", "M2", "L4"
            ],
            [
                "L2", "L2", "L2", "L3", "L1", "M3", "L4", "M4", "L2", "L3", "M1", "M2", "M2", "L4", "L2", "L1", "L3", "M3", "M4", "L4", "L4",
                "L1", "L2", "L3", "M2", "M4", "M4", "M3", "L1", "L2", "L2", "L3", "L4", "M4", "L1", "L2", "L3", "L4", "M2", "M4", "M4", "M4",
                "M1", "L1", "L4", "L3", "L2", "M4", "M4", "M1", "L4", "M2", "L1", "L2", "L3", "L4", "M1", "M1", "M1", "M3", "M4", "L3", "L1",
                "L1", "L1", "L2", "L4", "L4", "L4", "M3", "M3", "M3", "L3", "M2", "M1", "M4", "L1", "L4", "L2", "M1", "M1", "M3", "L3", "L1",
                "L1", "L4", "M4", "L2", "M1", "M1", "W", "L3", "M3", "M3", "L4", "L1", "M2", "M2", "M2", "L2", "L2", "M1", "L4", "M4", "L3",
                "L3", "L1", "L1", "L2", "M2", "M2", "M4", "L4", "L3", "M3", "L1", "W", "L2", "L3", "L3", "L3", "L4", "L4", "M4", "M3", "M2",
                "L1", "L4", "L2", "L3", "M3", "M3", "L1", "L4", "L2", "L3", "L3", "M3", "M2", "L4"
            ],
            [
                "M4", "L3", "M3", "L1", "M1", "M2", "L3", "L4", "L2", "L2", "M4", "M3", "M3", "L3", "L1", "L4", "M4", "M1", "L2", "L3", "L4",
                "L4", "L4", "M4", "M4", "M3", "L2", "L1", "L4", "M2", "M1", "L3", "L1", "L4", "L4", "M3", "M4", "M2", "L2", "L2", "L2", "L3",
                "L3", "L4", "L1", "W", "M3", "L2", "L2", "L4", "L3", "M4", "M4", "M2", "L2", "L1", "L1", "L1", "L4", "M3", "M2", "L3", "L3",
                "M1", "M1", "L1", "L2", "M3", "L4", "M4", "L1", "M2", "M2", "M2", "L3", "L4", "M4", "L2", "L1", "L1", "M1", "M1", "M1", "L3",
                "M4", "L2", "L1", "L1", "L4", "M2", "M2", "M1", "M1", "M3", "L3", "L2", "L4", "L1", "M4", "M4", "M4", "L3", "L2", "M1", "L4",
                "L1", "M2", "L3", "M3", "M3", "M3", "L4", "L1", "L2", "W", "L3", "L4", "L1", "L2", "M4", "L3", "L4", "M3", "L1", "L2", "M1",
                "L3", "L3", "L3", "M4", "L4", "L4", "L2", "M3", "M3", "L3", "M2", "M2", "L4", "L2"
            ],
            [
                "L4", "L4", "M4", "L3", "L1", "L2", "L4", "M1", "M4", "L3", "L1", "L4", "L2", "L2", "M3", "L3", "M1", "M1", "W", "L2", "L4",
                "L3", "M2", "L1", "L2", "L4", "M1", "M2", "M2", "L1", "M3", "L3", "M4", "M4", "M4", "L2", "L4", "M3", "L3", "M4", "L1", "W",
                "L2", "L4", "L3", "M3", "M2", "M2", "M2", "L2", "L1", "L4", "L3", "M4", "M2", "L2", "L4", "L4", "L4", "M1", "L3", "L3", "L3",
                "M4", "M4", "L1", "L1", "L2", "L4", "M3", "M3", "L3", "L3", "M2", "L1", "L1", "L1", "M4", "M3", "L4", "L2", "L3", "M4", "M1",
                "M3", "M3", "M3", "L4", "L1", "M2", "M4", "M4", "L3", "L4", "L4", "L1", "M1", "M1", "M3", "L2", "L2", "L4", "M2", "L1", "L3",
                "M4", "M1", "M1", "M1", "L4", "L1", "L2", "M4", "L3", "L3", "M2", "M2", "L4", "L2", "M3", "M3", "L1", "L3", "M4", "L2", "L4",
                "M3", "M1", "L1", "L1", "L3", "L2", "M3", "L4", "L1", "L3", "L2", "L2", "L2", "M2"
            ],
            [
                "L1", "M2", "M4", "M4", "M4", "L2", "M3", "L4", "L3", "L3", "M4", "M4", "M2", "M1", "L2", "L3", "M3", "L1", "L4", "L2", "M4",
                "M1", "M1", "L3", "L4", "L1", "M4", "M4", "M2", "L2", "L3", "L1", "L4", "M3", "M3", "M3", "M1", "M1", "L2", "L1", "L3", "L4",
                "M4", "M3", "M3", "M2", "M2", "L2", "L2", "L1", "L3", "L4", "M4", "W", "M3", "L1", "L3", "L3", "L4", "L2", "M1", "M1", "M1",
                "M2", "L3", "M4", "L4", "L2", "L1", "L3", "M4", "W", "L4", "M3", "M2", "M2", "M2", "L2", "M4", "L1", "L3", "M3", "L4", "M1",
                "L2", "L2", "L3", "L1", "L1", "L4", "M2", "M2", "L2", "L3", "M3", "L4", "L4", "L4", "L1", "M2", "L3", "M4", "L4", "L2", "L2",
                "L2", "L1", "M1", "M3", "M3", "L3", "L2", "L4", "L4", "M1", "L1", "L1", "M4", "L3", "L4", "L4", "M3", "L2", "M2", "M1", "L4",
                "L1", "L2", "M4", "L3", "L3", "L3", "L4", "L1", "L1", "L1", "L2", "M3", "L3", "L4"
            ]
        ],
        "FS_PICK_REELSET": [
            ["M1", "L1", "L3", "M2", "L2", "M4", "L3", "M3", "W", "L4", "M1"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L3", "M3", "W", "L4", "M1"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L3", "M3", "W", "L4", "M1"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L3", "M3", "W", "L4", "M1"],
            ["M1", "L1", "L3", "M2", "L2", "M4", "L3", "M3", "W", "L4", "M1"]
        ]
    };

    public static NO_WIN_REEL_DATA(): any {
        return {
            "reels": [
                [
                    "M2",
                    "M4",
                    "L2",
                    "L2",
                    "L2"
                ],
                [
                    "L3",
                    "L1",
                    "M3",
                    "L4",
                    "L4",
                    "L4"
                ],
                [
                    "L2",
                    "M3",
                    "M2",
                    "L4",
                    "M4",
                    "M4",
                    "L2"
                ],
                [
                    "M1",
                    "M4",
                    "M4",
                    "L3",
                    "L2",
                    "L1"
                ],
                [
                    "M4",
                    "L3",
                    "L2",
                    "L1",
                    "M2"
                ]
            ],
            "evaluatedArea": [
                [
                    "M4",
                    "L2",
                    "L2"
                ],
                [
                    "L1",
                    "M3",
                    "L4",
                    "L4"
                ],
                [
                    "M3",
                    "M2",
                    "L4",
                    "M4",
                    "M4"
                ],
                [
                    "M4",
                    "M4",
                    "L3",
                    "L2"
                ],
                [
                    "L3",
                    "L2",
                    "L1"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "wasFeatureBuy": false,
            "boostedBet": false,
            "brokeTheBank": false,
            "freeSpinsPlayed": 0,
            "freespinsLeft": 0,
            "serverTestInfo": {},
            "symbolSizes": [
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ]
            ],
            "featureInfo": [],
            "fsPicks": [
                -1,
                -1,
                -1,
                -1,
                -1
            ]
        }
    }

    public static getReelSetName(mode: string): string {
        if (mode === "GAMBLE") {
            return "NORMAL_REELSET";
        }
        return `${mode}_REELSET`;
    }

    public static degToRad(deg: number): number {
        return deg * (Math.PI / 180.0);
    }

    public static updateReelSets(): void {
        // Filter stacked symbols on REEL_SETS if any.
        for (let reelSetKey in this.REEL_SETS) {
            this.REEL_SETS[reelSetKey].forEach((reelSet: string[], reelId: number) => {
                this.REEL_SETS[reelSetKey][reelId] = StackedSymbol.filterStackedSymbolsReelSet(reelSet, reelId);
            });
        }
    }
}

export enum DDayFeatureNames {
    FIGHTER,
    TANK,
    BOMBER,
    ARTILLERY,
    ATOMIC_WILD
}
